import { ReactComponentManifest } from "web/entrypoints/common/setup";
// Components
import { LegacyOutOfStockProductPage } from "web/react/components/__LEGACY__/out-of-stock-product-page/out-of-stock-product-page";
import { InStockProductPage } from "web/react/pages/product/in-stock/in-stock-product-page/in-stock-product-page";
import { OutOfStockProductPage } from "web/react/pages/product/out-of-stock/out-of-stock-product-page";
import withRedux from "web/react/redux-provider";

const components: ReactComponentManifest = {
    LegacyOutOfStockProductPage: withRedux(LegacyOutOfStockProductPage),
    OutOfStockProductPage: withRedux(OutOfStockProductPage),
    InStockProductPage: withRedux(InStockProductPage),
};

export default components;
